<ui-header
    [navigationItems]="navigationItems"
    [shouldShowHeader]="true"
    [shouldShowUserProfile]="true"
    [user]="user$ | async"
    [userPhotoFile]="userPhotoFile$ | async"
    [IsEmployeeSearchAccessible]="isEmployeeSearchAccessible$ | async"
>
</ui-header>

<div class="pages-wrapper">
    <router-outlet></router-outlet>
</div>

<ui-spinner></ui-spinner>
